import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Discount = ApplicationRecord.extend({
  attrs: {
    customer_id: attr({ persist: false }),
    description: attr({ persist: false }),
    discount_amount: attr({ persist: false }),
    discounted_price: attr({ persist: false }),
    metadata: attr({ persist: false }),
    purchase_id: attr({ persist: false }),
    purchase_value: attr({ persist: false }),
    redemption: belongsTo({ type: 'vouchers-redemptions', persist: false }),
    redemption_id: attr({ persist: false }),
  },
  static: {
    endpoint: '/discounts',
    jsonapiType: 'vouchers-discounts',
  },
});

export default Discount;
